
import { getFunctions, httpsCallable } from 'firebase/functions'
import { autoMapFromFirestore, autoMapToFirestore } from '@trullock/firebase-common'

let createProxy = (type, path) => {
	let tgt = () => { }
	tgt.path = path;

	return new Proxy(tgt, {
		get: function(target, prop, receiver)
		{
			return createProxy(type, target.path ? target.path + '-' + prop : prop);
		},
		apply: async function(target, thisArg, [data, opts])
		{
			let fns = getFunctions(undefined, 'europe-west1');
	
			if(target.path.endsWith('warmUp'))
			{
				try
				{
					httpsCallable(fns, type)({
						warmUp: true
					});
				}
				catch(e)
				{
					let path = target.path.substring(0, target.path.length - 7);
					console.error(`Failed to warm up function ${path}`, e);
				}
				return;
			}
	
			try
			{
				let serialzised = autoMapToFirestore(data);
				let result = await httpsCallable(fns, type, opts || { })({
					fn: path,
					data: serialzised
				});
				let retval = autoMapFromFirestore(result.data) || {};
				if(retval.success == undefined)
					retval.success = true;
				return retval;
			}
			catch(e)
			{
				console.error(e);
				
				return { 
					success: false,
					error: e
				}
			}
		}
	})
};

export const commands = createProxy('commands');
export const queries = createProxy('queries');